import { Box } from '@material-ui/core';
import { useEffect, useState } from 'react';

import { TimeIntervalSelector } from '@/components/modules/Metrics/MetricAggregateViews/components/TimeIntervalSelector';
import { MetricMerchantGroupViews } from '@/components/modules/Metrics/MetricMerchantGroupViews';
import { TopMerchants } from '@/components/modules/Metrics/shared/components/TopMerchants/TopMerchants';
import { useTimeInterval } from '@/components/modules/Metrics/shared/hooks/useTimeInterval';
import { HomeHeader } from '@/components/shared/components/HomeHeader';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useScreen } from '@/hooks/useScreen';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MetricsHomeMerchantGroup = () => {
  const { userEntity } = useUserContext();

  const { sm } = useScreen(); //FIXME: provoking a re-render
  const { timeInterval, setTimeInterval } = useTimeInterval();

  const [merchantIds, setMerchantIds] = useState<string[] | undefined>(undefined);

  useEffect(() => {
    if (userEntity) {
      userEntity.getMerchantGroupMerchants().then((merchants) => {
        setMerchantIds(merchants?.map((merchant) => merchant.id) || []);
      });
    }
  }, [userEntity]);

  if (!userEntity || !merchantIds) return null;

  return (
    <>
      <HomeHeader username={userEntity.name} />

      <Box display={'flex'} flexDirection={sm ? 'row' : 'column-reverse'} mt={sm ? 0 : 6}>
        <Box flexGrow={1}>
          <MetricMerchantGroupViews merchantIds={merchantIds} timeInterval={timeInterval} />
          <Box my={8} />
          <div style={{ maxWidth: 600 }}>
            <TopMerchants timeInterval={timeInterval} />
          </div>
        </Box>
        <Box margin={sm ? '0 0 0 24px' : '0 auto 24px'} position={sm ? 'block' : 'relative'}>
          <TimeIntervalSelector
            type={sm ? 'button' : 'select'}
            timeInterval={timeInterval}
            setTimeInterval={setTimeInterval}
            style={{
              position: 'sticky',
              top: 160,
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export const MetricsHomeMerchantGroupModule = withPermissionsModule(MetricsHomeMerchantGroup);
